export const segmentStreamBlue = '#4d6dd3'
export const black = '#343434'
export const enabledGreen = '#89de6e'
